export default __webpack_public_path__ + "static/media/commit.200d12d2.svg";